export default function addText(c, options) {
	return new c.paper.PointText(options);
}